import { render, staticRenderFns } from "./variants.vue?vue&type=template&id=421cc6bc&scoped=true"
import script from "./variants.vue?vue&type=script&lang=js"
export * from "./variants.vue?vue&type=script&lang=js"
import style0 from "./variants.vue?vue&type=style&index=0&id=421cc6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421cc6bc",
  null
  
)

export default component.exports